import $ from 'jquery'
import { MessageOverlay } from './message-overlay'
import { Popup } from './popup'
import { Toolbar } from './toolbar'
import forEach from 'lodash-es/forEach'

const debug = require('debug')('pm:activity')
debug('loaded')

const Activity = {
  HOOK_FILTER_FORM: '.js-activity-filter-form',
  HOOK_FILTER_TRIGGER: '.js-activity-filter',
  HOOK_QUERY: '.js-activity-query',
  HOOK_QUERY_RESET: '.js-activity-query-reset',

  init: function () {
    debug('init')

    $('.js-quick-search-activity').trigger('focus')

    if ($('.c-activity').length) {
      // Trigger toolbar dropdowns and date ranges
      Toolbar.dateRangeLimit = 0
      Toolbar.dateRange()
      Toolbar.dropdowns()

      // Handle query events
      Activity.checkActiveQuery()
      $(document).on('keyup', Activity.HOOK_QUERY, Activity.checkActiveQuery)
      $(document).on('click', Activity.HOOK_QUERY_RESET, Activity.resetQuery)

      // Get initial filter count when page loads
      Activity.initialFilterCount()

      // Update active filter count when filters are toggled
      $(document).on(
        'change',
        '.js-activity-filter-form',
        Activity.updateFilterCount
      )
      $(document).on(
        'keyup',
        '.js-activity-filter-sender',
        Activity.updateFilterCount
      )

      // Reset filter states when closed
      $(Activity.HOOK_FILTER_TRIGGER).on('popover.close', Activity.closeFilter)
      $(document).on('click', '.js-close-activity-filter', function () {
        //Trigger close when canceling filters
        $(Activity.HOOK_FILTER_TRIGGER).trigger('popover.close')
      })

      // Fetch filters on first click
      $(document).one(
        'click',
        Activity.HOOK_FILTER_TRIGGER,
        Activity.fetchFilters
      )

      // Toggle bounce types when event filters are changed
      $(document).on('change', '.js-filter-bounced', Activity.toggleBounceTypes)
      $(document).on(
        'change',
        '.js-filter-bounced-types input[type="checkbox"]',
        Activity.bounceTypeChanged
      )
    }

    // Infinity scroll for recipient pages
    Activity.infinityScroll(
      $('.recipient-timeline-wrap .recipient-timeline'),
      function () {
        const message = 'Scrolling is limited to %limit% records.'

        Activity.unclutterDates()
        Activity.showMessagesLimitNotification(
          $('.recipient-timeline'),
          $('.timeline-item'),
          message
        )
        Popup.init()
      }
    )

    // Don't duplicate timeline dates
    Activity.unclutterDates()

    // Activity actions e.g. reactivating and bypassing
    $(document).on('click touchend', '.js-activity-action', Activity.action)

    // Collapse duplicate events on message page
    Activity.collapseDuplicateEvents()
    $(document).on(
      'click',
      '.js-show-timeline-items',
      Activity.showTimelineItems
    )
  },

  resetQuery: function () {
    $(Activity.HOOK_QUERY_RESET).addClass('is-hidden')
    $(Activity.HOOK_QUERY).val('')
    $(Activity.HOOK_FILTER_FORM).trigger('submit')
  },

  checkActiveQuery: function () {
    // Figure out whether to show reset button
    if ($(Activity.HOOK_QUERY).val() !== '') {
      $(Activity.HOOK_QUERY_RESET).removeClass('is-hidden')
    } else {
      $(Activity.HOOK_QUERY_RESET).addClass('is-hidden')
    }
  },

  action: function (event) {
    event.preventDefault()

    const $el = $(this)
    const successClass = $el.data('success-class')
    const successMsg = $el.data('success-msg')

    // Make sure this button hasn't been clicked
    if (!$el.hasClass(successClass) && !$el.hasClass('is-loading')) {
      $el.addClass('is-loading')

      // Hide visible tooltip
      $('.tooltip:visible').remove()

      // Make request
      $.ajax({
        method: 'POST',
        url: $el.attr('href'),
        dataType: 'text',
      })
        .done(function () {
          // Show success state and fade out
          $el
            .removeClass('is-loading js-tooltip u-btn--secondary')
            .addClass(successClass)
            .text(successMsg)
            .removeAttr('data-tooltip')

          // Update nearby label and avatar
          $el.siblings('.is-inactive').removeClass('is-inactive')
          $el.siblings('.u-avatar').removeClass('u-avatar--inactive')

          // Hide notifier on recipient page
          if ($el.parents('.notifier.error').length) {
            $el.parents('.notifier.error').delay('500').slideUp()
          }
        })
        .fail(function () {
          $el.removeClass('is-loading')

          MessageOverlay.show(
            'Sorry, something went wrong. If you keep seeing this error, <a href="/help" class="js-popup" data-container-class="c-popup c-popup--medium">get in touch</a> and we’ll help you out.',
            'error',
            60000
          )
        })
    }
  },

  infinityScroll: function (el, fn) {
    const settings = {
      loadingHtml:
        '<div class="u-is-loading u-is-loading--small u-relative"></div>',
      pagingSelector: '.pagination',
      nextSelector: '.pagination .b-next',
    }

    if (typeof fn !== 'undefined') {
      settings.callback = fn
    }

    if (el.length) {
      el.jscroll(settings)

      // Trigger scroll event to load more events if the Load more button is already in a visible area.
      $(window).trigger('scroll')
    }
  },

  unclutterDates: function () {
    if ($('.js-unclutter-dates').length === 0) {
      return
    }

    $('.js-unclutter-dates').each(function () {
      const timeline = $(this)
      let newDay

      timeline.find('.timestamp .date').each(function () {
        const date = $(this)

        if (date.text() === newDay) {
          date.hideMe()
        } else {
          newDay = date.text()
          date.showMe()
        }
      })
    })
  },

  showMessagesLimitNotification: function (el, children, message) {
    const limit = 1000

    if ($(children).length >= limit) {
      $(el).jscroll.destroy()
      $(el).after(
        '<p class="hint detached">' +
          message.replace(/%limit%/gi, limit) +
          '</p>'
      )
    }
  },

  initialFilterCount: function () {
    const $count = $('.js-activity-filter-count')

    // Only set the initial filter variable if it doesn't exist
    if (!Activity.initialFilters) {
      Activity.initialFilters = $('.js-activity-filter-hidden').length
    }

    // Show the label if filters are active
    if (Activity.initialFilters > 0) {
      $count.removeClass('is-hidden').text(Activity.initialFilters)
    } else {
      $count.addClass('is-hidden')
    }
  },

  updateFilterCount: function () {
    const $count = $('.js-activity-filter-count')
    const serialized = $('#filter-popover')
      .find('input, select')
      .serializeArray()
    let total = 0

    // Hide or show the filter count depending on what's active
    function updateCount() {
      if (total > 0) {
        $count.text(total).removeClass('is-hidden')
      } else {
        $count.addClass('is-hidden')
      }
    }

    // Generate the total active filters if there's serialized data
    if (serialized.length > 0) {
      forEach(serialized, function (key, index) {
        // Add to total if value is not empty
        if (key.value !== '') total++

        // If this is the last item
        if (index === serialized.length - 1) updateCount()
      })
    } else {
      updateCount()
    }
  },

  closeFilter: function (el, event) {
    event = event || {}

    // If the submit button is not being triggered, reset the filter state
    if (!$(event.target).is('.c-activity-filter_submit')) {
      $('#filter-popover').empty().html(Activity.initialFilterPayload)
      Activity.initialFilterCount()
    }
  },

  fetchFilters: function () {
    // Fetch filters from server
    $.ajax({
      data: $(Activity.HOOK_FILTER_FORM).serialize(),
      url: $(this).attr('href'),
    }).done(function (data) {
      // Populate filters
      $('#filter-popover').removeClass('u-is-loading').html(data)
      $('.js-activity-filter-hidden').remove()

      // Keep track of the initial state so if the user cancels we can reset the form
      Activity.initialFilterPayload = data
    })
  },

  toggleBounceTypes: function () {
    const $bounceFilters = $('.js-filter-bounced-types').find(
      'input[type="checkbox"]'
    )

    // Toggle bounce type sub filters if parent is active
    $bounceFilters.prop('checked', $(this).prop('checked'))
  },

  bounceTypeChanged: function () {
    // Check the parent bounced filter when toggled
    if ($(this).prop('checked')) $('.js-filter-bounced').prop('checked', true)
  },

  collapseDuplicateEvents: function () {
    const $el = $('.js-collapse-duplicates')

    $el.each(function (index, item) {
      // Only hide duplicate delayed events for now
      Activity.collapseEvent('Delayed', 'delayed events', $(item))
    })
  },

  collapseEvent: function (eventLabel, expandLabel, $item) {
    // Find duplicates of the event
    const $duplicates = $item.find(
      '.c-event:contains("' + eventLabel + '"):gt(0)'
    )

    // Check if there are duplicates
    if ($duplicates.length) {
      // Hide duplicates
      $duplicates.parents('.timeline-item').hide()

      // Add a link to expand the events
      $duplicates
        .parents('.timeline-item:last')
        .after(
          '<div class="timeline-item timeline-item--expand">' +
            '<h4 class="timeline-status timeline-status--multi-fail">' +
            '<a href="#" class="timeline-expand js-show-timeline-items">+' +
            $duplicates.length +
            ' ' +
            expandLabel +
            '</a>' +
            '</h4>' +
            '</div>'
        )
    }
  },

  showTimelineItems: function (event) {
    event.preventDefault()

    // Hide expand button and show hidden events
    $(this).parents('.timeline-item').hide().siblings('.timeline-item').show()
  },
}

$(Activity.init)
